import { render } from "./DetalharPosvenda.vue?vue&type=template&id=513c528b&scoped=true"
import script from "./DetalharPosvenda.vue?vue&type=script&lang=js"
export * from "./DetalharPosvenda.vue?vue&type=script&lang=js"

import "./DetalharPosvenda.vue?vue&type=style&index=0&id=513c528b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513c528b"]])

export default __exports__